import React from 'react';

const ServerError = React.lazy(() => import('./ServerError' /* webpackChunkName: "Deny" */));
const ServerErrorInitializer = () => <ServerError />;
export default ServerErrorInitializer;
